(function(){
    $(".account-click-me").on("click", function(){
        $(this).toggleClass("open");
        $(".account-dd").slideToggle();
    });
})();


(function(){
    const menuButtons = document.querySelectorAll('[data-mobile-menu-toggle="menu"]');
    const nav = document.querySelector('#AccessibleNav');

    let open = false;

    for (let i = 0; i < menuButtons.length; i++) {
        const el = menuButtons[i]
        
        el.addEventListener('click', function (e) {
            if (open === true) {
                el.classList.remove('is-open')
                nav.classList.remove('is-open')
                document.body.classList.remove('has-activeNavPages')
                el.setAttribute('aria-expanded', false)
            } else {
                el.classList.add('is-open')
                nav.classList.add('is-open')
                document.body.classList.add('has-activeNavPages')
                el.setAttribute('aria-expanded', true)
            }

            open = ! open
        })
    }
})();
